import { ref } from 'vue';
import { graphql } from '@/gql';

import { queryExecute } from '@/Utils/graphqlAPI';

const selectedPlan = ref('basic');

export const usePricePlan = () => {
  const setSelectedPlan = (value: string) => {
    selectedPlan.value = value;
  };

  const getExchangeRate = async (currency: string) => {
    const response = await queryExecute({
      query: graphql(`
        query ExchangeRate($currency: String!) {
          exchangeRate(currency: $currency) {
            rate
          }
        }
      `),
      variables: {
        currency,
      },
      fetchPolicy: 'no-cache',
    });

    return response.data.exchangeRate;
  };

  return {
    selectedPlan,

    setSelectedPlan,
    getExchangeRate,
  };
};
